import { render, staticRenderFns } from "./NotificationsTable.vue?vue&type=template&id=8f7c1a1e&scoped=true&"
import script from "./NotificationsTable.vue?vue&type=script&lang=js&"
export * from "./NotificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsTable.vue?vue&type=style&index=0&id=8f7c1a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7c1a1e",
  null
  
)

export default component.exports